export default __webpack_public_path__ + "static/media/icon-coin-storj.ad51ea16.svg";